
import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import Select from "react-select"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import IntlProps from "../state/helpers/IntlProps"
import { OrderStatus } from "./OrderStatus"
import { ORDER_STATUS_TYPE} from "./OrderStatusType"

type Props = {
    customStatusId?: string
    onStatusChange: (newStatusId: string) => void
}

const CustomOrderStatusSelect = (props: Props & IntlProps) => {

    const { customStatusId } = props
    const [orderCustomStatuses, setOrderCustomStatuses] = useState<OrderStatus[]>([])
    const [selectCustomStatusId, setSelectCustomStatusId] = useState<string>(customStatusId || "")

    useEffect(() => {
        AppContext.getApiClient().get("/order-statuses").then(r => {
            setOrderCustomStatuses(r.data)
        })
    }, [])

    const onStatusChange = (newStatusId: string) => {
        setSelectCustomStatusId(newStatusId)
    }

    const orderedOptions = orderCustomStatuses
        .filter(status => status.attributes.type === ORDER_STATUS_TYPE.StatusOrdered)
        .map(status => {
            return { label: status.attributes.name, value: status.id }
        })

    const completedOptions = orderCustomStatuses
        .filter(status => status.attributes.type === ORDER_STATUS_TYPE.StatusCompleted)
        .map(status => {
            return { label: status.attributes.name, value: status.id }
        })

    const options = [
        { label: <FormattedMessage id="triggers.status_name.not_applied" />, value: "" },
        { label: <FormattedMessage id="order.status.in_progress_label" />, value: "", disabled: true },
        ...orderedOptions,
        { label: <FormattedMessage id="order.status.completed_label" />, value: "", disabled: true },
        ...completedOptions
    ]

    return <Select
        disabled={false}
        clearable={false}
        options={options}
        value={selectCustomStatusId}
        onChange={(option) => {
            onStatusChange(option.value)
            props.onStatusChange(option.value)
        }}
    />
}

export default injectIntl(CustomOrderStatusSelect)


// WEBPACK FOOTER //
// ./src/order-status/SelectComponent.tsx